<div class="card"
    [attr.active]="active || null"
    [attr.disabled]="disabled || null"
    (click)="onSelect(value)">
    <h6 class="card-title">{{title}}</h6>
    <p class="card-description">{{description}}</p>
</div>